import { SWRConfiguration } from 'swr';

import { useArraySWR } from '~/hooks/useSWR';
import { fetchFromOldApi } from '~/services/Http';

export type EmployeeOtherHistoryType = {
  fOtherPositionId: number;
  fOtherPositionEmpId: number;
  fOtherPositionTitle: string;
  fOtherPositionSubtitle: string;
  fOtherPositionStartDate: string;
  fOtherPositionEndDate: string;
  fOtherPositionInfo: string;
  fOtherPositionAttachmentId: number;
  fOtherPositionAttachmentName: string;
  fOtherPositionAttachmentIsArchived: boolean;
};

export const getEmployeeOtherExperiences = (
  id: string,
): Promise<EmployeeOtherHistoryType[]> => {
  return fetchFromOldApi('/json/employee/' + id + '/dev/pos/other').then((r) =>
    r.json(),
  );
};

type PropsType = {
  employeeId: number;
};
export const useEmployeeOtherHistory = (
  props: PropsType,
  swrConfig?: SWRConfiguration,
  isDisabled?: boolean,
) => {
  const { employeeId } = props;

  const { data, isLoading, error } = useArraySWR<EmployeeOtherHistoryType>(
    !!employeeId && !isDisabled
      ? ['getEmployeeOtherExperiences', employeeId]
      : null,
    () => getEmployeeOtherExperiences(String(employeeId)),
    swrConfig,
  );

  return {
    data,
    isLoading,
    error,
  };
};
